import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import Form from '@/components/Form';
import { CreateMetricInput } from '@/types/schema';

import { getHabitEditorFormFields, validateHabitEditorForm } from './config';
import { HabitEditorProps } from './types';

const HabitEditor = (props: HabitEditorProps) => {
  const { t } = useTranslation(['OKRs', 'Metrics']);
  const { initialValues, setSubmitRef, onSubmit, isEdit, onChange } = props;

  const fields = useMemo(
    () => getHabitEditorFormFields({ initialValues, t, isEdit }),
    [initialValues, isEdit, t],
  );

  return (
    <Stack
      className="flex-1 px-32 pt-8 pb-28 xs:max-h-[55vh] xs:overflow-auto xs:px-16 xs:pb-8"
      direction="col">
      <Form<CreateMetricInput>
        fields={fields}
        formName="MetricEditor"
        initialValues={initialValues}
        setSubmitRef={setSubmitRef}
        validate={validateHabitEditorForm}
        onChange={onChange}
        onSubmit={onSubmit}
      />
    </Stack>
  );
};

export default HabitEditor;
